import styled, { css } from 'styled-components'

const Progress = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 0 ${theme.spacing(10)};
    max-width: 102rem;
    margin: 0 auto;

    > div {
      display: flex;
    }

    > progress {
      /* Remove the default appearance */
      appearance: none;

      /* Set dimensions, border, and border-radius */
      width: 100%;
      height: 0.4rem;
      border: none;

      &::-webkit-progress-bar {
        background-color: ${theme.palette.grey[100]};
      }

      &::-webkit-progress-value {
        background-color: ${theme.palette.black};
      }
    }
  `}
`

const Step = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(4)} ${theme.spacing(2)};
    flex-grow: 1;

    p {
      margin: 0;

      &.isFuture {
        opacity: 0.5;
      }
    }
  `}
`

const PastStep = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 3.2rem;
    background-color: ${theme.palette.grey[300]};

    svg {
      color: ${theme.palette.grey[500]}};
    }
  `}
`

const CurrentStep = styled.div`
  ${({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 3.2rem;
    border: 0.1rem solid ${theme.palette.black};
    background-color: ${theme.palette.black};
    color: ${theme.palette.white};
  `}
`

const FutureStep = styled(CurrentStep)`
  ${({ theme }) => css`
    background-color: transparent;
    border-color: ${theme.palette.grey[500]};
    color: ${theme.palette.black};
    opacity: 0.5;
  `}
`

export default {
  Progress,
  Step,
  PastStep,
  CurrentStep,
  FutureStep,
}
